import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "form-group row" };
const _hoisted_3 = {
    class: "col-sm-2 col-form-label",
    for: "inputLabel"
};
const _hoisted_4 = { class: "col-sm-10" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "form-group row" };
const _hoisted_7 = {
    class: "col-sm-2 col-form-label",
    for: "inputLink"
};
const _hoisted_8 = { class: "col-sm-10" };
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { class: "form-group row" };
const _hoisted_11 = { class: "certification-badge-output form-control" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-sm-6" };
const _hoisted_14 = {
    class: "col-form-label",
    for: "inputFcolor"
};
const _hoisted_15 = { class: "col-sm-6" };
const _hoisted_16 = {
    class: "col-form-label",
    for: "inputBGcolor"
};
const _hoisted_17 = { for: "inputDesc" };
const _hoisted_18 = { class: "mt-2 modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ColorPicker = _resolveComponent("ColorPicker");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "editCertification",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_CERTIFICATIONS_EDIT_CERTIFICATION')
        }, {
            default: _withCtx(() => [
                ($setup.certification)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_LABEL')), 1),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("p", {
                                        class: "form-control",
                                        placeholder: _ctx.$t('JTADM_CERTIFICATIONS_LABEL')
                                    }, _toDisplayString($setup.certification.label), 9, _hoisted_5)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_LINK')), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        id: "inputLink",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.certification.link) = $event)),
                                        type: "text",
                                        autocomplete: "off",
                                        placeholder: _ctx.$t('JTADM_CERTIFICATIONS_LINK')
                                    }, null, 8, _hoisted_9), [
                                        [_vModelText, $setup.certification.link]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("h3", {
                                        class: "badge",
                                        style: _normalizeStyle({ backgroundColor: '#' + $setup.bgcolor, color: '#' + $setup.fgcolor, fontSize: 18 })
                                    }, null, 4),
                                    ($setup.certification.slug)
                                        ? (_openBlock(), _createBlock($setup["CertificationTag"], {
                                            key: 0,
                                            classes: "medium",
                                            certification: $setup.certification
                                        }, null, 8, ["certification"]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_FONT_COLOR')), 1),
                                            _createElementVNode("div", {
                                                class: "form-group color-picker-holder",
                                                onMouseleave: _cache[4] || (_cache[4] = ($event) => ($setup.fgPickerVisible = false))
                                            }, [
                                                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "color-format" }, "HEX6", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-control",
                                                    id: "inputFcolor",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.fgcolor) = $event)),
                                                    readonly: "",
                                                    type: "text",
                                                    onClick: _cache[2] || (_cache[2] = ($event) => ($setup.fgPickerVisible = true))
                                                }, null, 512), [
                                                    [_vModelText, $setup.fgcolor]
                                                ]),
                                                ($setup.fgPickerVisible)
                                                    ? (_openBlock(), _createBlock(_component_ColorPicker, {
                                                        key: 0,
                                                        "pure-color": $setup.fgcolor,
                                                        "onUpdate:pureColor": _cache[3] || (_cache[3] = ($event) => (($setup.fgcolor) = $event)),
                                                        "disable-alpha": "",
                                                        "is-widget": "",
                                                        "default-popup": "",
                                                        "picker-type": "chrome",
                                                        format: "hex6"
                                                    }, null, 8, ["pure-color"]))
                                                    : _createCommentVNode("", true)
                                            ], 32)
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_BACKGROUND_COLOR')), 1),
                                            _createElementVNode("div", {
                                                class: "form-group color-picker-holder",
                                                onMouseleave: _cache[8] || (_cache[8] = ($event) => ($setup.bgPickerVisible = false))
                                            }, [
                                                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "color-format" }, "HEX6", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-control",
                                                    id: "inputBgcolor",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($setup.bgcolor) = $event)),
                                                    type: "text",
                                                    readonly: true,
                                                    onClick: _cache[6] || (_cache[6] = ($event) => ($setup.bgPickerVisible = true))
                                                }, null, 512), [
                                                    [_vModelText, $setup.bgcolor]
                                                ]),
                                                ($setup.bgPickerVisible)
                                                    ? (_openBlock(), _createBlock(_component_ColorPicker, {
                                                        key: 0,
                                                        "pure-color": $setup.bgcolor,
                                                        "onUpdate:pureColor": _cache[7] || (_cache[7] = ($event) => (($setup.bgcolor) = $event)),
                                                        "disable-alpha": "",
                                                        "is-widget": "",
                                                        "default-popup": "",
                                                        "picker-type": "chrome",
                                                        format: "hex6"
                                                    }, null, 8, ["pure-color"]))
                                                    : _createCommentVNode("", true)
                                            ], 32)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_DESCRIPTION')), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.locales, (locale) => {
                                return (_openBlock(), _createBlock($setup["BInputGroup"], {
                                    class: "mb-1",
                                    key: locale,
                                    prepend: locale
                                }, {
                                    default: _withCtx(() => [
                                        ($setup.certification.description)
                                            ? (_openBlock(), _createBlock($setup["BFormInput"], {
                                                key: 0,
                                                modelValue: $setup.certification.description[locale],
                                                "onUpdate:modelValue": ($event) => (($setup.certification.description[locale]) = $event),
                                                type: "text",
                                                placeholder: _ctx.$t('JTADM_CERTIFICATIONS_DESCRIPTION')
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["prepend"]));
                            }), 128))
                        ]),
                        _createElementVNode("footer", _hoisted_18, [
                            _createElementVNode("button", {
                                class: "btn btn-info text-white",
                                type: "submit",
                                onClick: _withModifiers($setup.saveCertification, ["prevent"])
                            }, _toDisplayString(_ctx.$t('JTADM_UPDATE')), 1),
                            _createElementVNode("button", {
                                class: "btn btn-danger",
                                type: "button",
                                onClick: _cache[9] || (_cache[9] = ($event) => ($setup.editCertification?.hide()))
                            }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
